import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import TopMetricsRow from "./TopMetricsRow";
import { ProjectedVolumeDataPoint } from "../../../pages/reviewAndPublish/model";

// Volume total = total of all units in the projected curve. The series is
// cumulative (0 → total across the shift), so the total is the peak of the
// `recommended` curve.
const getVolumeTotal = (
    points: ProjectedVolumeDataPoint[] | undefined
): number | undefined => {
    const values = (points ?? [])
        .map((point) => point.recommended)
        .filter((value): value is number => value != null);
    return values.length > 0 ? Math.max(...values) : undefined;
};

const mapStateToProps = (state: RootState) => ({
    primaryGradingVolumeData: state.reviewAndPublish.shiftPlanOutput?.primaryGradingVolume,
    recommendedVolumeTotal: getVolumeTotal(
        state.reviewAndPublish.shiftPlanOutput?.projectedPrimaryGradingVolume
    ),
    shiftTotals: state.reviewAndPublish.shiftPlanOutput?.shiftTotals,
    laborHoursDeltaPercent: state.reviewAndPublish.shiftPlanOutput?.shiftTotals?.laborHoursDeltaPercent,
});

export default connect(mapStateToProps)(TopMetricsRow);
